<template>
  <KioskTable/>
</template>

<script>

import KioskTable from '@/components/KioskTableFlag'

export default {
  name: 'KiosksFlag',
  components: {KioskTable
  }
}
</script>
